import { render, staticRenderFns } from "./p1s4Transactions.vue?vue&type=template&id=3b4c5f3e&scoped=true"
import script from "./p1s4Transactions.vue?vue&type=script&lang=js"
export * from "./p1s4Transactions.vue?vue&type=script&lang=js"
import style0 from "./p1s4Transactions.vue?vue&type=style&index=0&id=3b4c5f3e&prod&scoped=true&lang=css"
import style1 from "./p1s4Transactions.vue?vue&type=style&index=1&id=3b4c5f3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c5f3e",
  null
  
)

export default component.exports